<template>
    <div>
          <div class="bottom" id='bottom'>
          <div class="left">
              <div class="top_phone">
                  <div class="one">24小时客服热线：</div>
                  <div class="two">0760-88929118</div>
                  <div class="three">18022118773</div>
              </div>
              <div class="e_mail">
                  <div class="e_mail_left">
                      公司邮箱：
                  </div>
                  <div class="e_mail_right">
                      <div class="one">1694138860@qq.com</div>
                      <div class="two">chinaone_zs@126.com</div>
                  </div>
              </div>
              <div class="address">
                  <div class="address_left">
                      公司地址：
                  </div>
                  <div class="address_right">
                      <div class="one">中山市兴中道28号中山体育场附近</div>
                  </div>
              </div>
              
          </div>

          <div class="centre">
              <div class="list">
                  <div class="title">关于我们</div>
                  <div class="con">公司简介</div>
                  <div class="con">企业荣誉</div>
              </div>
              <div class="list">
                  <div class="title">服务项目</div>
                  <div class="con">方案策划</div>
                  <div class="con">设计服务</div>
                  <div class="con">方案定制</div>
              </div>
              <div class="list">
                  <div class="title">新闻资讯</div>
                  <div class="con">策划知识</div>
                  <div class="con">公司新闻</div>
                  <div class="con">业内新闻</div>
              </div>
              <div class="list">
                  <div class="title">联系我们</div>
                  <div class="con">联系方式</div>
                  <div class="con">在线留言</div>
                  <div class="con">公司地址</div>
              </div>
          </div>

          <div class="right">
              <div class="wechat_code">
                  <img src="~@/assets/wx.png">
                  <div class="title">关注中一公众号</div>
              </div>
              <div class="xcx_code">
                  <img src="~@/assets/code.jpg">
                  <div class="title">关注小程序</div>
              </div>
          </div>
      </div>

      <div class="icp_bottom">
          Copyright 2022-2032 中山中一广告策划有限公司  备案号：粤ICP备2022037566号-1 
      </div>
    </div>
</template>
      
<script>
export default {
  name: 'bottom',
  components: {
      
  },
  data () {
    return {
      
    }
  },
  mounted () {
        
  },
  methods:{
      
  },
  
}
</script>

<style lang='scss' scoped>
$zycolor:#CF2C2E;
.bottom{
  background: #222;
  color:#fff;
  display: flex;
  justify-content: space-between;
  padding: 40px 80px 20px 80px;
  .left{
      display: flex;
      flex-direction: column;
      width: 20%;
      .top_phone{
          display: flex;
          flex-direction: column;
          text-align: left;
          .two{
            font-size: 31px;
            margin:10px 0;
          }
          .three{
            font-size: 31px;
          }
      }

      .e_mail{
          display: flex;
          margin:30px 0;
          .e_mail_right{
            text-align: left;
            .one{
              margin:5px 0 10px 0;
            }
          }
      }
      .address{
          display: flex;
          
      }
  }

  .centre{
      display: flex;
      justify-content: space-around;
      width: 50%;
      .list{
        .title{
          margin-bottom:30px;
        }
        .con{
          color: #A1A1A1;
          margin-bottom: 15px;
          cursor: pointer;
        }
      }
  }
  .right{
    width: 30%;
    display: flex;
    justify-content: space-around;
    img{
      width: 140px;
      height: 140px;
    }
    .title{
      margin-top:10px;
    }
  }
}

.icp_bottom{
  width: 100%;
  padding:10px 0;
}
</style>